import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CAPeriodService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CAPeriods`);
    }
}